<template>
  <div>
    <base-crud
      crudName="Horas Adicionais"
      newText="Nova Hora adicional"
      :table="tableName"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

function msToTime(duration) {
  console.log(duration);
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor(duration / (1000 * 60 * 60));

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return hours + ":" + minutes + ":" + seconds;
}

export default {
  data: function () {
    return {
      tableName: "aditionalHourTable",
      users: [],
      pages: [],
      url: "",
      columns: [
        "id",
        "user_id",
        "responsible_id",
        "miliseconds",
        "created_at",
        "actions",
      ],
      tableData: [
        "id",
        "user_id",
        "responsible_id",
        "miliseconds",
        "created_at",
      ],
      options: {
        filterByColumn: true,
        filterable: [
          "id",
          "user_id",
          "responsible_id",
          "miliseconds",
          "created_at",
        ],
        sortable: [
          "id",
          "user_id",
          "responsible_id",
          "miliseconds",
          "created_at",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Usuário",
          responsible_id: "Responsável",
          miliseconds: "Tempo",
          created_at: "Criado em",
          actions: "Ações",
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user", "responsible"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user.name;
          },
          responsible_id: function (h, row, index) {
            return row.responsible.name;
          },
          miliseconds: function (h, row, index) {
            return msToTime(row.miliseconds);
          },
        },
      },
      endPoint: "aditionalHours/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        user_id: "user[name]",
        responsible_id: "responsible[name]",
        miliseconds: "miliseconds",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AditionalHour/Crud.vue